module.exports = __webpack_public_path__ + "img/marker_start.f5df06c1.svg";